import { Invoiceable, PAYMENT_MEANS_OPTIONS } from "@/modules/facturae/domain/Invoiceable";
import { CompanyDB } from "@/modules/facturae/domain/InvoiceListScreenData";
import { InvoiceListScreenData } from "../domain/InvoiceListScreenData";
import { Configuration } from "../domain/Configuration";


const headers_invoice = [

    {
        text: "Tipo",
        sortable: true,
        value: "kind",
    },
    {
        text: "Id",
        sortable: true,
        value: "id",
    },
    {
        text: "Estado",
        sortable: true,
        value: "state",
    },
    {
        text: "Número de factura",
        sortable: true,
        value: "invoice_number",
    },
    {
        text: "Número de factura externo",
        sortable: true,
        value: "external_invoice_number",
    },
    {
        text: "Nombre del cliente",
        sortable: true,
        value: "customer_name",
    },
    {
        text: "CIF del cliente",
        sortable: true,
        value: "customer_cif",
    },
    {
        text: "Fecha de factura",
        sortable: true,
        value: "invoice_date",
    },
    {
        text: "Importe total",
        sortable: true,
        value: "total_amount",
    },
    {
        text: "Fecha de vencimiento",
        sortable: true,
        value: "invoice_due_date",
    },
    {
        text: "Método de pago",
        sortable: true,
        value: "payment_means",
    },
    {
        text: "Estado de pago",
        sortable: true,
        value: "payment_state",
    },
    {
        text: "Id módulo contabilidad",
        sortable: true,
        value: "accounting_document_id"
    },
]
const headers_budget = [

    {
        text: "Tipo",
        sortable: true,
        value: "kind",
    },
    {
        text: "Id",
        sortable: true,
        value: "id",
    },
    {
        text: "Estado",
        sortable: true,
        value: "state",
    },
    {
        text: "Número de presupuesto",
        sortable: true,
        value: "invoice_number",
    },
    {
        text: "Nombre del cliente",
        sortable: true,
        value: "customer_name",
    },
    {
        text: "CIF del cliente",
        sortable: true,
        value: "customer_cif",
    },
    {
        text: "Fecha de presupuesto",
        sortable: true,
        value: "invoice_date",
    },
    {
        text: "Importe total",
        sortable: true,
        value: "total_amount",
    },
]
const headers_delivery_note = [
    {
        text: "Tipo",
        sortable: true,
        value: "kind",
    },
    {
        text: "Id",
        sortable: true,
        value: "id",
    },
    {
        text: "Estado",
        sortable: true,
        value: "state",
    },
    {
        text: "Número de albarán",
        sortable: true,
        value: "invoice_number",
    },
    {
        text: "Nombre del cliente",
        sortable: true,
        value: "customer_name",
    },
    {
        text: "CIF del cliente",
        sortable: true,
        value: "customer_cif",
    },
    {
        text: "Fecha de albarán",
        sortable: true,
        value: "invoice_date",
    },
    {
        text: "Importe total",
        sortable: true,
        value: "total_amount",
    },
]
const headers_proforma = [

    {
        text: "Tipo",
        sortable: true,
        value: "kind",
    },
    {
        text: "Id",
        sortable: true,
        value: "id",
    },
    {
        text: "Estado",
        sortable: true,
        value: "state",
    },
    {
        text: "Número de proforma",
        sortable: true,
        value: "invoice_number",
    },
    {
        text: "Nombre del cliente",
        sortable: true,
        value: "customer_name",
    },
    {
        text: "CIF del cliente",
        sortable: true,
        value: "customer_cif",
    },
    {
        text: "Fecha de proforma",
        sortable: true,
        value: "invoice_date",
    },
    {
        text: "Importe total",
        sortable: true,
        value: "total_amount",
    },
]

const headers_ticket = [
    {
        text: "Tipo",
        sortable: true,
        value: "kind",
    },
    {
        text: "Id",
        sortable: true,
        value: "id",
    },
    {
        text: "Estado",
        sortable: true,
        value: "state",
    },
    {
        text: "Número de factura",
        sortable: true,
        value: "invoice_number",
    },
    {
        text: "Número de factura externo",
        sortable: true,
        value: "external_invoice_number",
    },
    {
        text: "Fecha de factura",
        sortable: true,
        value: "invoice_date",
    },
    {
        text: "Importe total",
        sortable: true,
        value: "total_amount",
    },
    {
        text: "Fecha de vencimiento",
        sortable: true,
        value: "invoice_due_date",
    },
    {
        text: "Método de pago",
        sortable: true,
        value: "payment_means",
    },
    {
        text: "Estado de pago",
        sortable: true,
        value: "payment_state",
    },
    {
        text: "Id módulo contabilidad",
        sortable: true,
        value: "accounting_document_id"
    },
]
    
const headers_send_history = [ // cambiar a campos necesarios
    {
        text: "Tipo",
        sortable: true,
        value: "kind",
    },
    {
        text: "Id",
        sortable: true,
        value: "id",
    },
    {
        text: "Estado",
        sortable: true,
        value: "state",
    },
    {
        text: "Número de factura",
        sortable: true,
        value: "invoice_number",
    },
    {
        text: "Número de factura externo",
        sortable: true,
        value: "external_invoice_number",
    },
    {
        text: "Fecha de factura",
        sortable: true,
        value: "invoice_date",
    },
    {
        text: "Importe total",
        sortable: true,
        value: "total_amount",
    },
    {
        text: "Fecha de vencimiento",
        sortable: true,
        value: "invoice_due_date",
    },
    {
        text: "Método de pago",
        sortable: true,
        value: "payment_means",
    },
    {
        text: "Estado de pago",
        sortable: true,
        value: "payment_state",
    },
    {
        text: "Id módulo contabilidad",
        sortable: true,
        value: "accounting_document_id"
    },
]
    
export class VueInvoiceListScreenData implements InvoiceListScreenData{
    invoices: Invoiceable[];
    companydb_id: number;
    companydb: CompanyDB;
    companydbLoaded: boolean;
    invoices_headers: Object;
    selectedItems: Array<Object>;
    loadingItems: boolean;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Object;
    showSelect: boolean;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    hideHeaderCheckbox: boolean;
    mobile: boolean;
    totalItems: Number;
    loadingDownload: boolean;
    loadingExcelDownload: boolean;
    sort_by: string;
    limit: Number;
    offset: Number;
    snackbar: Object;
    search: string;
    actionMenu: boolean;
    configuration: Configuration;
    dirtyUploadedLogo: boolean;
    file: any;
    asyncJobId: number;
    asyncJobState: string;
    new_invoice: Invoiceable;
    createRectificativeDialog: boolean;
    externalRecInvDate: string;
    externalRecInvNumber: string;
    availableFilters: Object;
    invoiceableTypeName: string;
    invoiceableType: string;
    availableActions: Array<string>;
    hasActiveContract: boolean;
    redirectOptions: Array<Object>;
    menuList: boolean;
    mergeDeliveryNotesDialog: boolean;
    mergeDeliveryNotesModes: Object;
    mergeDeliveryNotesMode: string;
    mergeDeliveryNotesSelected: Array<any>;
    showPopUp: boolean;
    messagePopUp: string;
    showPopUpSuccessful: boolean;
    messagePopUpSuccessful: string;
    showGenerateRemittancePopUp: boolean;
    messageShowGenerateRemittancePopUp: string;
    invoiceableIdList: Array<number>;
    showPopUpPaymentMeans: boolean;
    messagePopUpPaymentMeans: string;
    paymentMeansOptions: Array<Object>;
    paymentMeans: string;
    showPopUpDueDate: boolean;
    messagePopUpDueDate: string;
    dueDate: string;
    showPopUpPaymentMeansDueDate: boolean;
    messagePopUpPaymentMeansDueDate: string;
    massiveSign:boolean;
    massiveSignToDraft:boolean;
    remittanceTypes: Array<Object>;
    showRemittancePaymentNo02Alert: boolean = false;
    showRemittanceTypePopUp: boolean = false;
    selectedRemittanceType: string = 'OOFF';
    today: Date
    templates: Object[]

    constructor(){
        this.invoiceableType = 'invoice'
        this.invoiceableTypeName = 'Factura'
        this.invoices_headers = headers_invoice
        this.availableActions = ['rectificative','remittance', 'duplicate','download_from_face', 'recurring_invoice', 'send_to_accounting', 'can_sign', 'massive_payment_means', 'massive_due_date']
        this.invoices = []
        this.companydb_id = 0
        this.companydb = {
            configuration: {
                auto_send_to_verifactu: false,
                sii_opt_checked: false,
                spanish_territory_opt_checked: false,
                no_application_checked: false,
                company_as_party: {
                    type: "",
                }
            }
        }
        this.companydbLoaded = false
        this.selectedItems = [];
        this.loadingItems = false;
        this.footerItemsPerPageText = "Registros por página:";
        this.footerItemsPerPageOptions = [5, 10, 50, 100];
        this.showSelect = true;
        this.textNoResults = "No se han encontrado registros";
        this.textLoading = "Cargando...";
        this.itemKey = "id";
        this.hideHeaderCheckbox = false;
        this.mobile = false;
        this.totalItems = 0;
        this.loadingDownload = false;
        this.loadingExcelDownload = false;
        this.sort_by = '-id'

        this.limit = 10;
        this.offset = 0;
        this.snackbar = {
            isVisible: false,
            text: '',
            color: '',
            timeout: 6000,
          }
        this.actionMenu = false;
        this.configuration = new Configuration();
        this.dirtyUploadedLogo = false;
        this.file = null;
        this.asyncJobState= 'done'
        this.asyncJobId= 0
        this.createRectificativeDialog = false
        this.externalRecInvDate = ''
        this.externalRecInvNumber = ''
        this.showPopUp = false
        this.messagePopUp = ''
        this.showPopUpSuccessful = false
        this.messagePopUpSuccessful = ''
        this.showGenerateRemittancePopUp = false
        this.messageShowGenerateRemittancePopUp = ''
        this.showPopUpPaymentMeans = false
        this.messagePopUpPaymentMeans = ''
        this.paymentMeansOptions = []
        this.paymentMeans=''
        this.showPopUpDueDate = false
        this.messagePopUpDueDate = ''
        this.dueDate = ''
        this.showPopUpPaymentMeansDueDate = false
        this.messagePopUpPaymentMeansDueDate = ''
        this.massiveSign = false

        this.availableFilters = {
            id: {
                'name': 'id',
                'label': 'Id',
                'value': 0,
                'type': 'text',
                'icon': 'mdi-numeric',
            },
            kind: {
                'name': 'kind',
                'label': 'Tipo',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'in_invoice', text: 'Recibida'},
                    { value: 'out_invoice', text: 'Emitida'},
                ],
                'multiple': false,
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-chart',
                'text':''
            },
            state: {
                'name': 'state',
                'label': 'Estado',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'draft', text: 'Borrador'},
                    { value: 'signed', text: 'Emitida'},
                    { value: 'sent', text: 'Enviada'},
                    { value: 'sent_via_mail', text: 'Enviada por mail'},
                    { value: 'recived', text: 'Recibida'},
                    { value: 'registered', text: 'Registrada'},
                    { value: 'confirmed', text: 'Confirmada'},
                    { value: 'paid', text: 'Pagado'},
                    { value: 'lost_connection', text: 'Conexión perdida'},
                    { value: 'rejected', text: 'Rechazada'},
                    { value: 'error', text: 'Error'},
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            },
            invoice_number: {
                'name': 'invoice_number',
                'label': 'Número de factura',
                'value': 0,
                'type': 'text',
                'icon': 'mdi-file-document',
            },
            info_third: {
                'name': 'info_third',
                'label': 'Datos del cliente',
                'value': '',
                'type': 'text',
                'icon': 'mdi-card-account-details',
            },
            invoice_date_from: {
                'name': 'invoice_date_from',
                'label': 'Fecha de factura desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            invoice_date_to: {
                'name': 'invoice_date_to',
                'label': 'Fecha de factura hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            total_amount: {
                'name': 'total_amount',
                'label': 'Importe total',
                'value': 0,
                'type': 'number',
                'icon': 'mdi-numeric',
            },
            invoice_due_date_from: {
                'name': 'invoice_due_date_from',
                'label': 'Fecha de vencimiento desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            invoice_due_date_to: {
                'name': 'invoice_due_date_to',
                'label': 'Fecha de vencimiento hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            payment_means: {
                'name': 'payment_means',
                'label': 'Método de pago',
                'user_values': [
                    { value: '', text: 'Todos' },
                    ...PAYMENT_MEANS_OPTIONS.filter(obj => obj.text !== '')
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-credit-card-outline',
                'text': '',
            },
            payment_state: {
                'name': 'payment_state',
                'label': 'Estado de pago',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'unpaid', text: 'No pagada'},
                    { value: 'paid', text: 'Pagada'},
                    { value: 'partially_paid', text: 'Parcialmente pagada'},
                    { value: 'overpaid', text: 'Sobrepagada'},
                    { value: 'overdue', text: 'Vencida'},
                    { value: 'pending', text: 'Pendiente'},
                    { value: 'rectified', text: 'Rectificada'},
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            },
            search_field: {
                'name': 'search_field',
                'label': 'Descripción de productos',
                'value': '',
                'type': 'text',
                'icon': 'mdi-magnify',
            },
            invoice_posted_to_accounting: {
                'name': 'invoice_posted_to_accounting',
                'label': 'Subida a contabilidad',
                'user_values': [
                    {value: '', text: 'Todos'}, 
                    {value: true, text: 'Si'},
                    {value: false, text: 'No'}
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            },
            invoice_year: {
                'name': 'invoice_year',
                'label': 'Año de factura',
                'value': 0,
                'type': 'number',
                'icon': 'mdi-calendar',
            },
        }
        this.hasActiveContract = false
        this.redirectOptions = [
            {
                text: 'Facturas',
                value: 'invoice-list'
            },
            {
                text: 'F.Simplificadas',
                value: 'ticket-list'
            },
            {
                text: 'Presupuestos',
                value: 'budget-list'
            },
            {
                text: 'Albaranes',
                value: 'delivery-note-list'
            },
            {
                text: 'Proformas',
                value: 'proforma-list'
            },
        ]
        this.menuList = false
        this.mergeDeliveryNotesDialog = false
        this.mergeDeliveryNotesModes = [
            {
                text: 'Separados',
                value: 'separated'
            },
            {
                text: 'Agrupados',
                value: 'merge'
            }
        ]
        this.mergeDeliveryNotesMode = ''
        this.mergeDeliveryNotesSelected = []
        this.invoiceableIdList = []
        this.remittanceTypes           = [
            { value: 'OOFF', text: 'Adeudo correspondiente a una operación con un único pago' },
            { value: 'FNAL', text: 'Último adeudo de una serie de adeudos recurrentes' },
            { value: 'FRST', text: 'Primer adeudo de una serie de adeudos recurrentes' },
            { value: 'RCUR', text: 'Adeudo recurrente que no es ni el primero ni el último de la serie' },
        ]
        this.today = new Date()
        this.templates = []
    }

    success_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }

    setLoading(loading:boolean){
        this.loadingItems = loading
    }

    setLoadinDownload(loading:boolean){
        this.loadingDownload = loading
    }

    setInvoices(invoices){
        this.invoices = invoices
    }

    setTotalItems(totalItems){
        this.totalItems = totalItems
    }
}

export class VueBudgetListScreenData implements InvoiceListScreenData{
    invoices: Invoiceable[];
    companydb_id: number;
    companydb: CompanyDB;
    companydbLoaded: boolean;
    invoices_headers: Object;
    selectedItems: Array<Object>;
    loadingItems: boolean;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Object;
    showSelect: boolean;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    hideHeaderCheckbox: boolean;
    mobile: boolean;
    totalItems: Number;
    loadingDownload: boolean;
    loadingExcelDownload: boolean;
    sort_by: string;
    limit: Number;
    offset: Number;
    snackbar: Object;
    search: string;
    actionMenu: boolean;
    configuration: Configuration;
    dirtyUploadedLogo: boolean;
    file: any;
    asyncJobId: number;
    asyncJobState: string;
    new_invoice: Invoiceable;
    createRectificativeDialog: boolean;
    externalRecInvDate: string;
    externalRecInvNumber: string;
    availableFilters: Object;
    invoiceableTypeName: string;
    invoiceableType: string;
    availableActions: Array<string>;
    hasActiveContract: boolean;
    redirectOptions: Array<Object>;
    menuList: boolean;
    mergeDeliveryNotesDialog: boolean;
    mergeDeliveryNotesModes: Object;
    mergeDeliveryNotesMode: string;
    mergeDeliveryNotesSelected: Array<any>;
    showPopUp: boolean;
    messagePopUp: string;
    showPopUpSuccessful: boolean;
    messagePopUpSuccessful: string;
    invoiceableIdList: Array<number>;
    paymentMeans: string;
    dueDate: string;
    remittanceTypes: Array<Object> = [];
    showRemittancePaymentNo02Alert: boolean = false;
    showRemittanceTypePopUp: boolean = false;
    selectedRemittanceType: string = '';
    today: Date
    templates: Object[]

    constructor(){
        this.invoiceableType = 'budget'
        this.invoiceableTypeName = 'Presupuesto'
        this.invoices_headers = headers_budget
        this.availableActions = ['generate_invoice', 'duplicate']
        this.invoices = []
        this.companydb_id = 0
        this.companydb = {
            configuration: {
                auto_send_to_verifactu: false,
                sii_opt_checked: false,
                spanish_territory_opt_checked: false,
                no_application_checked: false,
                company_as_party: {
                    type: "",
                }
            }
        }
        this.companydbLoaded = false
        this.selectedItems = [];
        this.loadingItems = false;
        this.footerItemsPerPageText = "Registros por página:";
        this.footerItemsPerPageOptions = [5, 10, 50, 100];
        this.showSelect = true;
        this.textNoResults = "No se han encontrado registros";
        this.textLoading = "Cargando...";
        this.itemKey = "id";
        this.hideHeaderCheckbox = false;
        this.mobile = false;
        this.totalItems = 0;
        this.loadingDownload = false;
        this.loadingExcelDownload = false;
        this.sort_by = '-id';
        this.limit = 10;
        this.offset = 0;
        this.templates = []
        this.snackbar = {
            isVisible: false,
            text: '',
            color: '',
            timeout: 6000,
          }
        this.actionMenu = false;
        this.configuration = new Configuration()
        this.dirtyUploadedLogo = false;
        this.file = null;
        this.asyncJobState= 'done'
        this.asyncJobId= 0
        this.createRectificativeDialog = false
        this.externalRecInvDate = ''
        this.externalRecInvNumber = ''
        this.showPopUp = false
        this.messagePopUp = ''
        this.showPopUpSuccessful = false
        this.messagePopUpSuccessful = ''
        this.availableFilters = {
            id: {
                'name': 'id',
                'label': 'Id',
                'value': 0,
                'type': 'text',
                'icon': 'mdi-numeric',
            },
            kind: {
                'name': 'kind',
                'label': 'Tipo',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'in_invoice', text: 'Recibido'},
                    { value: 'out_invoice', text: 'Emitido'},
                ],
                'multiple': false,
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-chart',
                'text':''
            },
            state: {
                'name': 'state',
                'label': 'Estado',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'draft', text: 'Borrador'},
                    { value: 'issued', text: 'Emitido'},
                    { value: 'b_sent', text: 'Enviado'},
                    { value: 'accepted', text: 'Aceptado'},
                    { value: 'invoiced', text: 'Facturado'},
                    { value: 'b_rejected', text: 'Rechazado'},
                    { value: 'error', text: 'Error'},
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            },
            invoice_number: {
                'name': 'invoice_number',
                'label': 'Número de presupuesto',
                'value': 0,
                'type': 'text',
                'icon': 'mdi-file-document',
            },
            info_third: {
                'name': 'info_third',
                'label': 'Datos del cliente',
                'value': '',
                'type': 'text',
                'icon': 'mdi-card-account-details',
            },
            invoice_date_from: {
                'name': 'invoice_date_from',
                'label': 'Fecha de presupuesto desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            invoice_date_to: {
                'name': 'invoice_date_to',
                'label': 'Fecha de presupuesto hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            total_amount: {
                'name': 'total_amount',
                'label': 'Importe total',
                'value': 0,
                'type': 'number',
                'icon': 'mdi-numeric',
            },
            invoice_due_date_from: {
                'name': 'invoice_due_date_from',
                'label': 'Fecha de vencimiento desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            invoice_due_date_to: {
                'name': 'invoice_due_date_to',
                'label': 'Fecha de vencimiento hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
        }
        this.hasActiveContract = false
        this.redirectOptions = [
            {
                text: 'Facturas',
                value: 'invoice-list'
            },
            {
                text: 'F.Simplificadas',
                value: 'ticket-list'
            },
            {
                text: 'Presupuestos',
                value: 'budget-list'
            },
            {
                text: 'Albaranes',
                value: 'delivery-note-list'
            },
            {
                text: 'Proformas',
                value: 'proforma-list'
            },
        ]
        this.menuList = false
        this.mergeDeliveryNotesDialog = false
        this.mergeDeliveryNotesModes = [
            {
                text: 'Separados',
                value: 'separated'
            },
            {
                text: 'Agrupados',
                value: 'merge'
            }
        ]
        this.mergeDeliveryNotesMode = ''
        this.mergeDeliveryNotesSelected = []
        this.invoiceableIdList = []
        this.today = new Date()
    }

    success_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }

    setLoading(loading:boolean){
        this.loadingItems = loading
    }

    setLoadinDownload(loading:boolean){
        this.loadingDownload = loading
    }

    setInvoices(invoices){
        this.invoices = invoices
    }

    setTotalItems(totalItems){
        this.totalItems = totalItems
    }
}

export class VueDeliveryNoteListScreenData implements InvoiceListScreenData {
    invoices: Invoiceable[];
    companydb_id: number;
    companydb: CompanyDB;
    companydbLoaded: boolean;
    invoices_headers: Object;
    selectedItems: Array<Object>;
    loadingItems: boolean;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Object;
    showSelect: boolean;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    hideHeaderCheckbox: boolean;
    mobile: boolean;
    totalItems: Number;
    loadingDownload: boolean;
    loadingExcelDownload: boolean;
    sort_by: string;
    limit: Number;
    offset: Number;
    snackbar: Object;
    search: string;
    actionMenu: boolean;
    configuration: Configuration;
    dirtyUploadedLogo: boolean;
    file: any;
    asyncJobId: number;
    asyncJobState: string;
    new_invoice: Invoiceable;
    createRectificativeDialog: boolean;
    externalRecInvDate: string;
    externalRecInvNumber: string;
    availableFilters: Object;
    invoiceableTypeName: string;
    invoiceableType: string;
    availableActions: Array<string>;
    hasActiveContract: boolean;
    redirectOptions: Array<Object>;
    menuList: boolean;
    mergeDeliveryNotesDialog: boolean;
    mergeDeliveryNotesMode: string;
    mergeDeliveryNotesModes: Object;
    mergeDeliveryNotesSelected: Array<any>;
    showPopUp: boolean;
    messagePopUp: string;
    showPopUpSuccessful: boolean;
    messagePopUpSuccessful: string;
    invoiceableIdList: Array<number>;
    paymentMeans: string;
    dueDate: string;
    remittanceTypes: Array<Object> = []
    showRemittancePaymentNo02Alert: boolean = false;
    showRemittanceTypePopUp: boolean = false;
    selectedRemittanceType: string = '';
    today: Date
    templates: Object[]

    constructor(){
        this.invoiceableType = 'delivery_note'
        this.invoiceableTypeName = 'Albarán'
        this.invoices_headers = headers_delivery_note
        this.availableActions = ['generate_invoice', 'duplicate']
        this.invoices = []
        this.companydb_id = 0
        this.companydb = {
            configuration: {
                auto_send_to_verifactu: false,
                sii_opt_checked: false,
                spanish_territory_opt_checked: false,
                no_application_checked: false,
                company_as_party: {
                    type: "",
                }
            }
        }
        this.companydbLoaded = false
        this.selectedItems = [];
        this.loadingItems = false;
        this.templates = []
        this.footerItemsPerPageText = "Registros por página:";
        this.footerItemsPerPageOptions = [5, 10, 50, 100];
        this.showSelect = true;
        this.textNoResults = "No se han encontrado registros";
        this.textLoading = "Cargando...";
        this.itemKey = "id";
        this.hideHeaderCheckbox = false;
        this.mobile = false;
        this.totalItems = 0;
        this.loadingDownload = false;
        this.loadingExcelDownload = false;
        this.sort_by = '-id'
        this.limit = 10;
        this.offset = 0;
        this.snackbar = {
            isVisible: false,
            text: '',
            color: '',
            timeout: 6000,
          }
        this.actionMenu = false;
        this.configuration = new Configuration();
        this.dirtyUploadedLogo = false;
        this.file = null;
        this.asyncJobState= 'done'
        this.asyncJobId= 0
        this.createRectificativeDialog = false
        this.externalRecInvDate = ''
        this.externalRecInvNumber = ''
        this.showPopUp = false
        this.messagePopUp = ''
        this.showPopUpSuccessful = false
        this.messagePopUpSuccessful = ''
        this.availableFilters = {
            id: {
                'name': 'id',
                'label': 'Id',
                'value': 0,
                'type': 'text',
                'icon': 'mdi-numeric',
            },
            kind: {
                'name': 'kind',
                'label': 'Tipo',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'in_invoice', text: 'Recibido'},
                    { value: 'out_invoice', text: 'Emitido'},
                ],
                'multiple': false,
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-chart',
                'text':''
            },
            state: {
                'name': 'state',
                'label': 'Estado',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'draft', text: 'Borrador'},
                    { value: 'issued', text: 'Emitido'},
                    { value: 'b_sent', text: 'Enviado por mail'},
                    { value: 'accepted', text: 'Aceptado'},
                    { value: 'invoiced', text: 'Facturado'},
                    { value: 'b_rejected', text: 'Rechazado'},
                    { value: 'error', text: 'Error'},
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            },
            invoice_number: {
                'name': 'invoice_number',
                'label': 'Número de albarán',
                'value': 0,
                'type': 'text',
                'icon': 'mdi-file-document',
            },
            info_third: {
                'name': 'info_third',
                'label': 'Datos del cliente',
                'value': '',
                'type': 'text',
                'icon': 'mdi-card-account-details',
            },
            invoice_date_from: {
                'name': 'invoice_date_from',
                'label': 'Fecha de albarán desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            invoice_date_to: {
                'name': 'invoice_date_to',
                'label': 'Fecha de albarán hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            total_amount: {
                'name': 'total_amount',
                'label': 'Importe total',
                'value': 0,
                'type': 'number',
                'icon': 'mdi-numeric',
            },
            invoice_due_date_from: {
                'name': 'invoice_due_date_from',
                'label': 'Fecha de vencimiento desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            invoice_due_date_to: {
                'name': 'invoice_due_date_to',
                'label': 'Fecha de vencimiento hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },

        }
        this.hasActiveContract = false
        this.redirectOptions = [
            {
                text: 'Facturas',
                value: 'invoice-list'
            },
            {
                text: 'F.Simplificadas',
                value: 'ticket-list'
            },
            {
                text: 'Presupuestos',
                value: 'budget-list'
            },
            {
                text: 'Albaranes',
                value: 'delivery-note-list'
            },
            {
                text: 'Proformas',
                value: 'proforma-list'
            },
        ]
        this.menuList = false
        this.mergeDeliveryNotesDialog = false
        this.mergeDeliveryNotesModes = [
            {
                text: 'Separados',
                value: 'separated'
            },
            {
                text: 'Agrupados',
                value: 'merge'
            }
        ]
        this.mergeDeliveryNotesMode = ''
        this.mergeDeliveryNotesSelected = []
        this.invoiceableIdList = []
        this.today = new Date()
    }

    success_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }

    setLoading(loading:boolean){
        this.loadingItems = loading
    }

    setLoadinDownload(loading:boolean){
        this.loadingDownload = loading
    }

    setInvoices(invoices){
        this.invoices = invoices
    }

    setTotalItems(totalItems){
        this.totalItems = totalItems
    }
}

export class VueProformaListScreenData implements InvoiceListScreenData{
    invoices: Invoiceable[];
    companydb_id: number;
    companydb: CompanyDB;
    companydbLoaded: boolean;
    invoices_headers: Object;
    selectedItems: Array<Object>;
    loadingItems: boolean;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Object;
    showSelect: boolean;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    hideHeaderCheckbox: boolean;
    mobile: boolean;
    totalItems: Number;
    loadingDownload: boolean;
    loadingExcelDownload: boolean;
    sort_by: string;
    limit: Number;
    offset: Number;
    snackbar: Object;
    search: string;
    actionMenu: boolean;
    configuration: Configuration;
    dirtyUploadedLogo: boolean;
    file: any;
    asyncJobId: number;
    asyncJobState: string;
    new_invoice: Invoiceable;
    createRectificativeDialog: boolean;
    externalRecInvDate: string;
    externalRecInvNumber: string;
    availableFilters: Object;
    invoiceableTypeName: string;
    invoiceableType: string;
    availableActions: Array<string>;
    hasActiveContract: boolean;
    redirectOptions: Array<Object>;
    menuList: boolean;
    mergeDeliveryNotesDialog: boolean;
    mergeDeliveryNotesModes: Object;
    mergeDeliveryNotesMode: string;
    mergeDeliveryNotesSelected: Array<any>;
    showPopUp: boolean;
    messagePopUp: string;
    showPopUpSuccessful: boolean;
    messagePopUpSuccessful: string;
    invoiceableIdList: Array<number>;
    paymentMeans: string;
    dueDate: string;
    remittanceTypes: Array<Object> = [];
    showRemittancePaymentNo02Alert: boolean = false;
    showRemittanceTypePopUp: boolean = false;
    selectedRemittanceType: string = '';
    today: Date
    templates: Object[]

    constructor(){
        this.invoiceableType = 'proforma'
        this.invoiceableTypeName = 'Proforma'
        this.invoices_headers = headers_proforma
        this.availableActions = ['generate_invoice', 'duplicate']
        this.invoices = []
        this.companydb_id = 0
        this.companydb = {
            configuration: {
                auto_send_to_verifactu: false,
                sii_opt_checked: false,
                spanish_territory_opt_checked: false,
                no_application_checked: false,
                company_as_party: {
                    type: "",
                }
            }
        }
        this.companydbLoaded = false
        this.selectedItems = [];
        this.templates = []
        this.loadingItems = false;
        this.footerItemsPerPageText = "Registros por página:";
        this.footerItemsPerPageOptions = [5, 10, 50, 100];
        this.showSelect = true;
        this.textNoResults = "No se han encontrado registros";
        this.textLoading = "Cargando...";
        this.itemKey = "id";
        this.hideHeaderCheckbox = false;
        this.mobile = false;
        this.totalItems = 0;
        this.loadingDownload = false;
        this.loadingExcelDownload = false;
        this.sort_by = '-id';
        this.limit = 10;
        this.offset = 0;
        this.snackbar = {
            isVisible: false,
            text: '',
            color: '',
            timeout: 6000,
          }
        this.actionMenu = false;
        this.configuration = new Configuration()
        this.dirtyUploadedLogo = false;
        this.file = null;
        this.asyncJobState= 'done'
        this.asyncJobId= 0
        this.createRectificativeDialog = false
        this.externalRecInvDate = ''
        this.externalRecInvNumber = ''
        this.showPopUp = false
        this.messagePopUp = ''
        this.showPopUpSuccessful = false
        this.messagePopUpSuccessful = ''
        this.availableFilters = {
            id: {
                'name': 'id',
                'label': 'Id',
                'value': 0,
                'type': 'text',
                'icon': 'mdi-numeric',
            },
            kind: {
                'name': 'kind',
                'label': 'Tipo',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'in_invoice', text: 'Recibido'},
                    { value: 'out_invoice', text: 'Emitido'},
                ],
                'multiple': false,
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-chart',
                'text':''
            },
            state: {
                'name': 'state',
                'label': 'Estado',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'draft', text: 'Borrador'},
                    { value: 'issued', text: 'Emitido'},
                    { value: 'b_sent', text: 'Enviado'},
                    { value: 'accepted', text: 'Aceptado'},
                    { value: 'invoiced', text: 'Facturado'},
                    { value: 'b_rejected', text: 'Rechazado'},
                    { value: 'error', text: 'Error'},
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            },
            invoice_number: {
                'name': 'invoice_number',
                'label': 'Número de presupuesto',
                'value': 0,
                'type': 'text',
                'icon': 'mdi-file-document',
            },
            info_third: {
                'name': 'info_third',
                'label': 'Datos del cliente',
                'value': '',
                'type': 'text',
                'icon': 'mdi-card-account-details',
            },
            invoice_date_from: {
                'name': 'invoice_date_from',
                'label': 'Fecha de presupuesto desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            invoice_date_to: {
                'name': 'invoice_date_to',
                'label': 'Fecha de presupuesto hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            total_amount: {
                'name': 'total_amount',
                'label': 'Importe total',
                'value': 0,
                'type': 'number',
                'icon': 'mdi-numeric',
            },
            invoice_due_date_from: {
                'name': 'invoice_due_date_from',
                'label': 'Fecha de vencimiento desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            invoice_due_date_to: {
                'name': 'invoice_due_date_to',
                'label': 'Fecha de vencimiento hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
        }
        this.hasActiveContract = false
        this.redirectOptions = [
            {
                text: 'Facturas',
                value: 'invoice-list'
            },
            {
                text: 'F.Simplificadas',
                value: 'ticket-list'
            },
            {
                text: 'Presupuestos',
                value: 'budget-list'
            },
            {
                text: 'Albaranes',
                value: 'delivery-note-list'
            },
            {
                text: 'Proformas',
                value: 'proforma-list'
            },
        ]
        this.menuList = false
        this.mergeDeliveryNotesDialog = false
        this.mergeDeliveryNotesModes = [
            {
                text: 'Separados',
                value: 'separated'
            },
            {
                text: 'Agrupados',
                value: 'merge'
            }
        ]
        this.mergeDeliveryNotesMode = ''
        this.mergeDeliveryNotesSelected = []
        this.invoiceableIdList = []
        this.today = new Date()
    }

    success_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }

    setLoading(loading:boolean){
        this.loadingItems = loading
    }

    setLoadinDownload(loading:boolean){
        this.loadingDownload = loading
    }

    setInvoices(invoices){
        this.invoices = invoices
    }

    setTotalItems(totalItems){
        this.totalItems = totalItems
    }
}
export class VueTicketListScreenData implements InvoiceListScreenData{
    invoices: Invoiceable[];
    companydb_id: number;
    companydb: CompanyDB;
    companydbLoaded: boolean;
    invoices_headers: Object;
    selectedItems: Array<Object>;
    loadingItems: boolean;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Object;
    showSelect: boolean;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    hideHeaderCheckbox: boolean;
    mobile: boolean;
    totalItems: Number;
    loadingDownload: boolean;
    loadingExcelDownload: boolean;
    sort_by: string;
    limit: Number;
    offset: Number;
    snackbar: Object;
    search: string;
    actionMenu: boolean;
    configuration: Configuration;
    dirtyUploadedLogo: boolean;
    file: any;
    asyncJobId: number;
    asyncJobState: string;
    new_invoice: Invoiceable;
    createRectificativeDialog: boolean;
    externalRecInvDate: string;
    externalRecInvNumber: string;
    availableFilters: Object;
    invoiceableTypeName: string;
    invoiceableType: string;
    availableActions: Array<string>;
    hasActiveContract: boolean;
    redirectOptions: Array<Object>;
    menuList: boolean;
    mergeDeliveryNotesDialog: boolean;
    mergeDeliveryNotesModes: Object;
    mergeDeliveryNotesMode: string;
    mergeDeliveryNotesSelected: Array<any>;
    showPopUp: boolean;
    messagePopUp: string;
    showPopUpSuccessful: boolean;
    messagePopUpSuccessful: string;
    showGenerateRemittancePopUp: boolean;
    messageShowGenerateRemittancePopUp: string;
    invoiceableIdList: Array<number>;
    showPopUpPaymentMeans: boolean;
    messagePopUpPaymentMeans: string;
    paymentMeansOptions: Array<Object>;
    paymentMeans: string;
    showPopUpDueDate: boolean;
    messagePopUpDueDate: string;
    dueDate: string;
    showPopUpPaymentMeansDueDate: boolean;
    messagePopUpPaymentMeansDueDate: string;
    massiveSign:boolean;
    remittanceTypes: Array<Object> = [];
    showRemittancePaymentNo02Alert: boolean = false;
    showRemittanceTypePopUp: boolean = false;
    selectedRemittanceType: string = '';
    today: Date
    templates: Object[]

    constructor(){
        this.invoiceableType = 'ticket'
        this.invoiceableTypeName = 'Facturas Simplificada'
        this.invoices_headers = headers_ticket
        this.availableActions = ['duplicate','download_from_face','send_to_accounting', 'can_sign']
        this.invoices = []
        this.companydb_id = 0
        this.companydb = {
            configuration: {
                auto_send_to_verifactu: false,
                sii_opt_checked: false,
                spanish_territory_opt_checked: false,
                no_application_checked: false,
                company_as_party: {
                    type: "",
                }
            }
        }
        this.companydbLoaded = false
        this.selectedItems = [];
        this.loadingItems = false;
        this.footerItemsPerPageText = "Registros por página:";
        this.footerItemsPerPageOptions = [5, 10, 50, 100];
        this.showSelect = true;
        this.textNoResults = "No se han encontrado registros";
        this.textLoading = "Cargando...";
        this.itemKey = "id";
        this.hideHeaderCheckbox = false;
        this.mobile = false;
        this.totalItems = 0;
        this.loadingDownload = false;
        this.loadingExcelDownload = false;
        this.sort_by = '-id'

        this.limit = 10;
        this.offset = 0;
        this.snackbar = {
            isVisible: false,
            text: '',
            color: '',
            timeout: 6000,
          }
        this.actionMenu = false;
        this.configuration = new Configuration();
        this.dirtyUploadedLogo = false;
        this.file = null;
        this.asyncJobState= 'done'
        this.asyncJobId= 0
        this.createRectificativeDialog = false
        this.externalRecInvDate = ''
        this.externalRecInvNumber = ''
        this.showPopUp = false
        this.messagePopUp = ''
        this.showPopUpSuccessful = false
        this.messagePopUpSuccessful = ''
        this.showGenerateRemittancePopUp = false
        this.messageShowGenerateRemittancePopUp = ''
        this.showPopUpPaymentMeans = false
        this.messagePopUpPaymentMeans = ''
        this.paymentMeansOptions = []
        this.paymentMeans=''
        this.showPopUpDueDate = false
        this.templates = []
        this.messagePopUpDueDate = ''
        this.dueDate = ''
        this.showPopUpPaymentMeansDueDate = false
        this.messagePopUpPaymentMeansDueDate = ''
        this.massiveSign = false

        this.availableFilters = {
            id: {
                'name': 'id',
                'label': 'Id',
                'value': 0,
                'type': 'text',
                'icon': 'mdi-numeric',
            },
            kind: {
                'name': 'kind',
                'label': 'Tipo',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'in_invoice', text: 'Recibida'},
                    { value: 'out_invoice', text: 'Emitida'},
                ],
                'multiple': false,
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-chart',
                'text':''
            },
            state: {
                'name': 'state',
                'label': 'Estado',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'draft', text: 'Borrador'},
                    { value: 'signed', text: 'Emitida'},
                    { value: 'sent', text: 'Enviada'},
                    { value: 'sent_via_mail', text: 'Enviada por mail'},
                    { value: 'recived', text: 'Recibida'},
                    { value: 'registered', text: 'Registrada'},
                    { value: 'confirmed', text: 'Confirmada'},
                    { value: 'paid', text: 'Pagado'},
                    { value: 'lost_connection', text: 'Conexión perdida'},
                    { value: 'rejected', text: 'Rechazada'},
                    { value: 'error', text: 'Error'},
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            },
            invoice_number: {
                'name': 'invoice_number',
                'label': 'Número de factura',
                'value': 0,
                'type': 'text',
                'icon': 'mdi-file-document',
            },
            info_third: {
                'name': 'info_third',
                'label': 'Datos del cliente',
                'value': '',
                'type': 'text',
                'icon': 'mdi-card-account-details',
            },
            invoice_date_from: {
                'name': 'invoice_date_from',
                'label': 'Fecha de factura desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            invoice_date_to: {
                'name': 'invoice_date_to',
                'label': 'Fecha de factura hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            total_amount: {
                'name': 'total_amount',
                'label': 'Importe total',
                'value': 0,
                'type': 'number',
                'icon': 'mdi-numeric',
            },
            invoice_due_date_from: {
                'name': 'invoice_due_date_from',
                'label': 'Fecha de vencimiento desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            invoice_due_date_to: {
                'name': 'invoice_due_date_to',
                'label': 'Fecha de vencimiento hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            payment_state: {
                'name': 'payment_state',
                'label': 'Estado de pago',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'unpaid', text: 'No pagada'},
                    { value: 'paid', text: 'Pagada'},
                    { value: 'partially_paid', text: 'Parcialmente pagada'},
                    { value: 'overpaid', text: 'Sobrepagada'},
                    { value: 'overdue', text: 'Vencida'},
                    { value: 'pending', text: 'Pendiente'},
                    { value: 'rectified', text: 'Rectificada'},
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            },
            search_field: {
                'name': 'search_field',
                'label': 'Descripción de productos',
                'value': '',
                'type': 'text',
                'icon': 'mdi-magnify',
            },
            invoice_posted_to_accounting: {
                'name': 'invoice_posted_to_accounting',
                'label': 'Subida a contabilidad',
                'user_values': [
                    {value: '', text: 'Todos'}, 
                    {value: true, text: 'Si'},
                    {value: false, text: 'No'}
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            }
        }
        this.hasActiveContract = false
        this.redirectOptions = [
            {
                text: 'Facturas',
                value: 'invoice-list'
            },
            {
                text: 'F.Simplificadas',
                value: 'ticket-list'
            },
            {
                text: 'Presupuestos',
                value: 'budget-list'
            },
            {
                text: 'Albaranes',
                value: 'delivery-note-list'
            },
            {
                text: 'Proformas',
                value: 'proforma-list'
            },
        ]
        this.menuList = false
        this.mergeDeliveryNotesDialog = false
        this.mergeDeliveryNotesModes = [
            {
                text: 'Separados',
                value: 'separated'
            },
            {
                text: 'Agrupados',
                value: 'merge'
            }
        ]
        this.mergeDeliveryNotesMode = ''
        this.mergeDeliveryNotesSelected = []
        this.invoiceableIdList = []
        this.today = new Date()
    }

    success_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }

    setLoading(loading:boolean){
        this.loadingItems = loading
    }

    setLoadinDownload(loading:boolean){
        this.loadingDownload = loading
    }

    setInvoices(invoices){
        this.invoices = invoices
    }

    setTotalItems(totalItems){
        this.totalItems = totalItems
    }
}

export class SendHistoryLogScreenData implements InvoiceListScreenData {
    invoices: Invoiceable[];
    companydb_id: number;
    companydb: CompanyDB;
    companydbLoaded: boolean;
    invoices_headers: Object;
    selectedItems: Array<Object>;
    loadingItems: boolean;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Object;
    showSelect: boolean;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    hideHeaderCheckbox: boolean;
    mobile: boolean;
    totalItems: Number;
    loadingDownload: boolean;
    loadingExcelDownload: boolean;
    sort_by: string;
    limit: Number;
    offset: Number;
    snackbar: Object;
    search: string;
    actionMenu: boolean;
    configuration: Configuration;
    dirtyUploadedLogo: boolean;
    file: any;
    templates: Object[];
    asyncJobId: number;
    asyncJobState: string;
    new_invoice: Invoiceable;
    createRectificativeDialog: boolean;
    externalRecInvDate: string;
    externalRecInvNumber: string;
    availableFilters: Object;
    invoiceableTypeName: string;
    invoiceableType: string;
    availableActions: Array<string>;
    hasActiveContract: boolean;
    redirectOptions: Array<Object>;
    menuList: boolean;
    mergeDeliveryNotesDialog: boolean;
    mergeDeliveryNotesModes: Object;
    mergeDeliveryNotesMode: string;
    mergeDeliveryNotesSelected: Array<any>;
    showPopUp: boolean;
    messagePopUp: string;
    showPopUpSuccessful: boolean;
    messagePopUpSuccessful: string;
    showGenerateRemittancePopUp: boolean;
    messageShowGenerateRemittancePopUp: string;
    invoiceableIdList: Array<number>;
    showPopUpPaymentMeans: boolean;
    messagePopUpPaymentMeans: string;
    paymentMeansOptions: Array<Object>;
    paymentMeans: string;
    showPopUpDueDate: boolean;
    messagePopUpDueDate: string;
    dueDate: string;
    showPopUpPaymentMeansDueDate: boolean;
    messagePopUpPaymentMeansDueDate: string;
    massiveSign:boolean;
    remittanceTypes: Array<Object> = [];
    showRemittancePaymentNo02Alert: boolean = false;
    showRemittanceTypePopUp: boolean = false;
    selectedRemittanceType: string = '';
    today: Date

    constructor() { 
        // Tipo y nombre para esa vista de historial
        this.invoiceableType = 'send_history_log'
        this.invoiceableTypeName = 'Historial de envíos'
 
        // Cabeceras específicas para el log
        this.invoices_headers = headers_send_history
        this.availableActions = ['rectificative','remittance', 'duplicate','download_from_face', 'recurring_invoice', 'send_to_accounting', 'can_sign', 'massive_payment_means', 'massive_due_date', 'send_history']
        this.invoices = []
        this.companydb_id = 0
        this.companydb = {
            configuration: {
                auto_send_to_verifactu: false,
                sii_opt_checked: false,
                spanish_territory_opt_checked: false,
                no_application_checked: false,
                company_as_party: {
                    type: "",
                }
            }
        }
        this.companydbLoaded = false
        this.selectedItems = []
        this.loadingItems = false
        this.limit = 10
        this.offset = 0
        this.search = ''
        this.sort_by = ''
        this.showSelect = true
        this.itemKey = 'id'
        this.hideHeaderCheckbox = false
        this.footerItemsPerPageText    = 'Registros por página:'
        this.footerItemsPerPageOptions = [5, 10, 50, 100]
        this.mobile
        this.textNoResults = 'No se han encontrado registros'
        this.textLoading = 'Cargando...'

        // Download states (no usados, pero parte de la estructura)
        this.loadingDownload    = false
        this.loadingExcelDownload = false

        // Snackbar y pop-ups (vacíos por defecto)
        this.snackbar                   = { isVisible: false, text: '', color: '', timeout: 6000 }
        this.showPopUp                  = false
        this.messagePopUp               = ''
        this.showPopUpSuccessful        = false
        this.messagePopUpSuccessful     = ''
        this.showGenerateRemittancePopUp = false
        this.messageShowGenerateRemittancePopUp = ''

        // Resto de propiedades (no usadas en el log, pero requeridas por la interfaz)
        this.actionMenu                = false
        this.configuration             = new Configuration()
        this.dirtyUploadedLogo         = false
        this.file                      = null
        this.templates                 = []
        this.asyncJobState             = 'done'
        this.asyncJobId                = 0
        this.new_invoice               = null as any
        this.createRectificativeDialog = false
        this.externalRecInvDate        = ''
        this.externalRecInvNumber      = ''
        this.availableFilters          = {}
        this.hasActiveContract         = false
        this.redirectOptions           = []
        this.menuList                  = false
        this.mergeDeliveryNotesDialog  = false
        this.mergeDeliveryNotesModes   = {}
        this.mergeDeliveryNotesMode    = ''
        this.mergeDeliveryNotesSelected = []
        this.invoiceableIdList         = []
        this.showPopUpPaymentMeans     = false
        this.messagePopUpPaymentMeans  = ''
        this.paymentMeansOptions       = []
        this.paymentMeans              = ''
        this.showPopUpDueDate          = false
        this.messagePopUpDueDate       = ''
        this.dueDate                   = ''
        this.showPopUpPaymentMeansDueDate = false
        this.messagePopUpPaymentMeansDueDate = ''
        this.massiveSign               = false
        this.today                     = new Date()
    }
    
    setLoading(loading: boolean) {
        this.loadingItems = loading
    }
    setInvoices(invoices: Invoiceable[]) {
        this.invoices = invoices
    }
    setTotalItems(totalItems: number) {
        this.totalItems = totalItems
    }
    setPage(page: number) {
        this.offset = (page - 1) * Number(this.limit)
    }
    setSearch(term: string) {
        this.search = term
    }
    setSort(sortBy: string) {
        this.sort_by = sortBy
    }
    setLoadinDownload(loading: any): void {
        throw new Error("Method not implemented.");
    }
    success_message(message: any): void {
        throw new Error("Method not implemented.");
    }
    error_message(message: any): void {
        throw new Error("Method not implemented.");
    }
}